module.exports = __webpack_public_path__ + "static/media/400047_02.6d06c400.png";